var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('monitors',{ref:"monitors",attrs:{"loading":_vm.isLoading,"monitors":_vm.monitors || [],"all-fields":_vm.allFields},on:{"edit":_vm.editMonitor,"run-query":_vm.runQuery}}),_c('edit-monitor-popup',{ref:"editMonitor",on:{"deleted":_vm.fetchMonitors,"saved":_vm.fetchMonitors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }